import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Guest extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        console.log('content', content);

        return (
            <div className={styles.bGray}>
                <div className={styles.GuestContainer}>
                    <ul className={styles.mkList} cmpp-type="s">
                        {content.map((item, index) => {
                            return (
                                <li className={index === 0 ? styles.mt0 : ''} key={index}>
                                    <div className={styles.tt}>
                                        <a href={item.summary} target="_blank">
                                            专题
                                        </a>
                                    </div>
                                    <div className={styles.pic}>
                                        <a href={item.summary} target="_blank">
                                            <img
                                                src={item.thumbnails.image[1].url}
                                                title="请添加图片名称"
                                                alt="请添加图片名称"
                                                className={styles.trans}
                                            />
                                        </a>
                                    </div>
                                    <div className={styles.txt}>
                                        <h3>
                                            <a href={item.summary} target="_blank">
                                                {item.title}
                                            </a>
                                        </h3>
                                    </div>
                                    <div className={styles.zMore}>
                                        <a href={item.summary} target="_blank">
                                            阅读全文
                                        </a>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Guest);
